/**
 * Enumeration des différents éléments possible sur la carte DFCI
 */
export enum DFCI_ELEMENT {
  AIRE = "AIRE",
  PISTE = "PISTE",
  DEBROUSSAILLEMENT = "DEBROUSSAILLEMENT",
  PANNEAU = "PANNEAU",
}
